import axios from 'axios';

const ajax = axios.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    },
});

export const pushDataToGtm = data => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(data);
};

export const notifyInventory = () => {
    pushDataToGtm(document.querySelector('._js-post-inventory-notification').dataset.notifyproductinventory);
};

const pushPaymentOption = paymentOption => {
    ajax.get('/publicapi/Gtm/PushPaymentOption/', {
        params: {
            paymentOption
        }
    }).then(response => {
        pushDataToGtm(response);
    });
};

export const locateStore = storeName => {
    const datalayer = $('._js-inventory-list');
    if (datalayer && datalayer.data('storelocation')) {
        datalayer.data('storelocation').eventLabel = storeName;
        pushDataToGtm(datalayer);
    }
};

export const pushShippingOption = shippingOption => {
    ajax.get('/publicapi/Gtm/PushShippingOption', {
        params: {
            shippingOption
        }
    }).then(response => {
        pushDataToGtm(response);
    });
};

const pushLogin = value => {
    ajax.get('/publicapi/Gtm/PushShippingOption', {
        params: {
            value
        }
    }).then(response => {
        pushDataToGtm(response);
    });
};

const pushRegister = () => {
    ajax.get('/publicapi/Gtm/pushRegister').then(response => {
        pushDataToGtm(response);
    });
};

const pushPayment = paymentoption => {
    ajax.get('/publicapi/Gtm/PushPayment', {
        params: {
            paymentoption
        }
    }).then(response => {
        pushDataToGtm(response);
    });
};

const gtmdata = () => {
    document.querySelectorAll('input[name="FormData.SelectedPaymentOption"]').forEach(i => {
        i.addEventListener('change', e => {
            pushPaymentOption(e.target.value);
        });
    });

    document.querySelectorAll('input[name="login"]').forEach(i => {
        i.addEventListener('change', e => {
            pushLogin(e.target.value);
        });
    });

    document.querySelectorAll('input[name="FormData.RegisterCustomer"]').forEach(i => {
        i.addEventListener('change', e => {
            pushRegister();
        });
    });

    document.querySelectorAll('._js-product-variation a').forEach(i => {
        i.addEventListener('click', e => {
            pushDataToGtm(e.target.closest('._js-product-variation').dataset.variation);
        });
    });

    document.querySelectorAll('._js-promo-click').forEach(t => {
        t.addEventListener('click', e => {
            const element = e.target;
            const data = element.dataset.promoclick
                ? element.dataset.promoclick
                : element.closest('._js-promo-click').dataset.promoclick;
            pushDataToGtm(JSON.parse(data));
        });
    });

    document.querySelectorAll('._js-btn-pay').forEach(t => {
        t.addEventListener('click', e => {
            const checked = document.querySelector('input[name="FormData.SelectedPaymentOption"]');
            if (checked && checked.value) {
                pushPayment(checked.value);
            }
        });
    });

    document.querySelectorAll('._js-store-inventory-click').forEach(t => {
        t.addEventListener('click', e => {
            const inventory = e.target.closest('._js-store-inventory-click');

            if (inventory && inventory.dataset.storeinventory) {
                pushDataToGtm(inventory.dataset.storeinventory);
            }
        });
    });

    document.querySelectorAll('._js-store-inventory-search').forEach(t => {
        t.addEventListener('click', e => {
            const inputElement = document.getElementById('inventoryPostnumber');
            const dataLayerContent = e.target.dataset.storesearch;
            if (dataLayerContent) {
                const dataLayer = JSON.parse(dataLayerContent);
                dataLayer.eventLabel = inputElement.value;
                pushDataToGtm(dataLayer);
            }
        });
    });
};

export const init = () => {
    gtmdata();
};
